import OpenCourseShare from './openCourse/OpenCourseShare'
import ElaborateCourseShare from './elaborateCourse/ElaborateCourseShare'

export default {
	OpenCourseShare: OpenCourseShare,
	ElaborateCourseShare: ElaborateCourseShare
}